import { usePsd2Params } from './usePsd2Params';
import { useVerifyPsd2 } from './useVerifyPsd2';

export const usePsd2 = () => {
  const psd2Params = usePsd2Params();
  const verifyPsd2 = useVerifyPsd2();

  return { psd2Params, verifyPsd2 };
};
